// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPolicyLiteBalanceReminderDto } from './IPolicyLiteBalanceReminderDto';
import {
    IPolicyLiteBalanceReminderDtoFromJSON,
    IPolicyLiteBalanceReminderDtoFromJSONTyped,
    IPolicyLiteBalanceReminderDtoToJSON,
    IPolicyLiteBalanceReminderDtoToJSONTyped,
} from './IPolicyLiteBalanceReminderDto';

/**
 * 
 * @export
 * @interface IBalanceReminderDto
 */
export interface IBalanceReminderDto {
    /**
     * 
     * @type {boolean}
     * @memberof IBalanceReminderDto
     */
    is_limited_payout_definition?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IBalanceReminderDto
     */
    employee_id?: number;
    /**
     * 
     * @type {Array<IPolicyLiteBalanceReminderDto>}
     * @memberof IBalanceReminderDto
     */
    policies?: Array<IPolicyLiteBalanceReminderDto>;
    /**
     * 
     * @type {number}
     * @memberof IBalanceReminderDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IBalanceReminderDto
     */
    organization_path?: string;
}

/**
 * Check if a given object implements the IBalanceReminderDto interface.
 */
export function instanceOfIBalanceReminderDto(value: object): value is IBalanceReminderDto {
    return true;
}

export function IBalanceReminderDtoFromJSON(json: any): IBalanceReminderDto {
    return IBalanceReminderDtoFromJSONTyped(json, false);
}

export function IBalanceReminderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IBalanceReminderDto {
    if (json == null) {
        return json;
    }
    return {
        
        'is_limited_payout_definition': json['isLimitedPayoutDefinition'] == null ? undefined : json['isLimitedPayoutDefinition'],
        'employee_id': json['employeeId'] == null ? undefined : json['employeeId'],
        'policies': json['policies'] == null ? undefined : ((json['policies'] as Array<any>).map(IPolicyLiteBalanceReminderDtoFromJSON)),
        'organization_id': json['organizationId'] == null ? undefined : json['organizationId'],
        'organization_path': json['organizationPath'] == null ? undefined : json['organizationPath'],
    };
}

export function IBalanceReminderDtoToJSON(json: any): IBalanceReminderDto {
    return IBalanceReminderDtoToJSONTyped(json, false);
}

export function IBalanceReminderDtoToJSONTyped(value?: IBalanceReminderDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isLimitedPayoutDefinition': value['is_limited_payout_definition'],
        'employeeId': value['employee_id'],
        'policies': value['policies'] == null ? undefined : ((value['policies'] as Array<any>).map(IPolicyLiteBalanceReminderDtoToJSON)),
        'organizationId': value['organization_id'],
        'organizationPath': value['organization_path'],
    };
}

